import type { LinkCategory, LinkItem } from './interface'

export const links: LinkCategory[] = [
    {
        name: '<strong>Strefa klienta</strong>',
        items: [
            {
                name: 'Usługi dodatkowe',
                link: 'https://www.plus.pl/uslugi',
            },
            {
                name: 'Doładuj telefon',
                link: 'https://doladuj.plus.pl/',
            },
            {
                name: 'Rejestruj kartę',
                link: 'https://www.plus.pl/rejestracja',
            },
            {
                name: 'Aplikacja iPlus',
                link: 'https://www.plus.pl/uslugi/aplikacja-iplus',
            },
            {
                name: 'Informacja o przetwarzaniu danych',
                link: 'https://www.plus.pl/dane-osobowe',
            },
            {
                name: 'Zgody marketingowe',
                link: 'https://www.plus.pl/zgody-marketingowe',
            },
            {
                name: 'Status zamówienia',
                link: 'https://www.plus.pl/status-zamowienia',
            },
            {
                name: 'Status przeniesienia numeru',
                link: 'https://www.plus.pl/sprawdz-status-mnp',
            },
            {
                name: 'Weryfikacja sprzętu ratalnego',
                link: 'https://www.plus.pl/formularze/formularz-imei',
            },
            {
                name: 'Akt o Usługach Cyfrowych',
                link: 'https://www.plus.pl/aktualnosci-i-komunikaty/akt-o-uslugach-cyfrowych',
            },
        ],
    },
    {
        name: '<strong>Pomoc</strong>',
        items: [
            {
                name: 'Porady - FAQ',
                link: 'https://bok.plus.pl',
            },
            {
                name: 'Skonfiguruj telefon',
                link: 'https://ustaw.plus.pl/konfiguruj-telefon',
            },
            {
                name: '5G w Plusie',
                link: 'https://www.plus.pl/5g',
            },
            {
                name: 'Mapa zasięgu internetu',
                link: 'https://www.plus.pl/mapa-zasiegu',
            },
            {
                name: 'Regulaminy i cenniki',
                link: 'https://www.plus.pl/regulaminy-i-cenniki',
            },
            {
                name: 'Numery Premium Rate',
                link: 'https://www.plus.pl/uslugi/uslugi-premium',
            },
            {
                name: 'Internet LTE - pliki do pobrania',
                link: 'https://www.plus.pl/internet-pobierz',
            },
            {
                name: 'Sprawdź prędkość internetu',
                link: 'https://www.plus.pl/speedtest',
            },
            {
                name: 'Darmowe zwroty',
                link: 'https://www.plus.pl/zwroty',
            },
        ],
    },
    {
        name: '<strong>Pozostałe usługi</strong>',
        items: [
            {
                name: 'Forum Plusa',
                link: 'https://bok.plus.pl/forum/',
            },
            {
                name: 'Telewizja internetowa',
                link: 'https://sklep.polsatbox.pl/telewizja-internetowa-ott',
            },
            {
                name: 'Telewizja satelitarna',
                link: 'https://sklep.polsatbox.pl/telewizja-satelitarna',
            },
            {
                name: 'Polsat Box Go',
                link: 'https://www.plus.pl/uslugi/polsatboxgo',
            },
        ],
    },
]

export const contact: LinkItem[] = [
    {
        name: 'Kontakt',
        link: 'https://www.plus.pl/kontakt',
    },
    {
        name: 'O firmie',
        link: 'https://www.plus.pl/news/ospolce',
    },
    {
        name: 'Biuro prasowe',
        link: 'https://plus.pl/blog/biuro-prasowe',
    },
    {
        name: 'Komunikaty',
        link: 'https://www.plus.pl/aktualnosci-i-komunikaty',
    },
    {
        name: 'Nośnik trwały',
        link: ' https://www.plus.pl/aktualnosci-i-komunikaty/trwalynosnik',
    },
    {
        name: 'Praca',
        link: 'https://www.plus.pl/news/kariera',
    },
    {
        name: 'Polityka prywatności',
        link: 'https://www.plus.pl/polityka-prywatnosci',
    },
]

export const defaultValue = ''

export const accordionItems = [
    { value: 'item-1', title: 'Strefa klienta', content: links[0].items },
    { value: 'item-2', title: 'Pomoc', content: links[1].items },
    { value: 'item-3', title: 'Pozostałe usługi', content: links[2].items },
]

export const footerCopy = [
    `© ${new Date().getFullYear()} Polkomtel Sp. z o.o. Wszystkie prawa zastrzeżone LTE™ to zastrzeżony znak towarowy należący do ETSI.`,
    `© ${new Date().getFullYear()} Disney i podmioty powiązane`,
]
